function setResponsiveBackgroundImages() {
    var windowWidth = window.innerWidth || document.documentElement.clientWidth  || document.body.clientWidth;
    $('.js-addBackgroundImage').each(function() {
        var backgroundImage = $( this ).attr('src');
        var mobileImage = $( this ).data('mobileImage');
        var desktopImage = $( this ).data('desktopImage');
        if( windowWidth >= 1366 ){
            backgroundImage = desktopImage;
        }else if( windowWidth < 1366 ){
            backgroundImage = mobileImage;
        }
        $( this ).attr('style', 'background-image:url(' + backgroundImage + ');' );
        $( this ).addClass('backgroundImage');
    });
}
$(function() {
   setResponsiveBackgroundImages();
});
$( window ).resize(function() {
    setResponsiveBackgroundImages();
});
